
export const ConstantsRoutes = {
  HOME: "/",
  QUOTATION: "/cotizador",
  QUOTATION_FORM: '/cotizador/formulario',
  POLICIES: '/aviso-privacidad',
}